import {settingsPagePaths} from "../../config/config";

export type SettingsPageSection = keyof typeof settingsPagePaths;

export const keyboardKeyCounts = [25, 49, 61, 76, 88];
